import { FunctionComponent } from 'preact';
import { useCallback } from 'preact/hooks';

import { Button, ButtonProps } from '../Button/Button';
import { usePaywall } from '../../hooks/PaywallProvider';
import { useTranslation } from '../../../../utils/useTranslation';
import ns from '../../translations';
import { usePlayer } from '../../hooks/PlayerProvider';

type LoginButtonProps = ButtonProps;

export const LoginButton: FunctionComponent<LoginButtonProps> = (props) => {
  const player = usePlayer();
  const { t } = useTranslation(ns);
  const { login } = usePaywall();

  const label = t('Sign in', {}, { noJSX: true });

  const handleLoginClick = useCallback(() => {
    player.trigger('login', {
      button: {
        elementType: 'LoginButton',
        title: label,
      },
    });

    login();
  }, [player, label, login]);

  return (
    <Button onClick={handleLoginClick} {...props}>
      {label}
    </Button>
  );
};
